<template>
  <div class="wrapper-answer-section border border-secondary-20 rounded-lg px-6 py-7">
    <div
      class="answers-and-submissions flex flex-col gap-5"
      ref="answerRef"
    >
      <QuestionContent
        :question="question"
        :scoring="scoring"
        :order="order"
        :totalQuiz="totalQuiz"
      />
      <component
        :is="answerComponent"
        :answer="answer"
      />
    </div>
  </div>
</template>

<script>
import QuestionContent from '@/components-v2/presentation-report/ReportAudienceDetail/QuestionContent.vue'
import TwoColumnQuizReview from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/TwoColumnQuizReview.vue'
import ShortAnswer from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/ShortAnswer.vue'
import CorrectOrder from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/CorrectOrder.vue'
import MatchPair from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/MatchPair.vue'
import ListSubmission from '@/components-v2/presentation-report/ReportAudienceDetail/open-question/ListSubmission.vue'
import BlockSubmission from '@/components-v2/presentation-report/ReportAudienceDetail/open-question/BlockSubmission.vue'

import constants from '@/constant'

const { INDIVIDUAL_REPORT_QUESTION_TYPE } = constants

const QUIZ_TYPES = [INDIVIDUAL_REPORT_QUESTION_TYPE.SHORT_ANSWER]

const answerComponentMap = {
  [INDIVIDUAL_REPORT_QUESTION_TYPE.WORD_CLOUD]: 'ListSubmission',
  [INDIVIDUAL_REPORT_QUESTION_TYPE.OPEN_ENDED]: 'BlockSubmission',
  [INDIVIDUAL_REPORT_QUESTION_TYPE.BRAIN_STORM]: 'BlockSubmission',
  [INDIVIDUAL_REPORT_QUESTION_TYPE.SHORT_ANSWER]: 'ShortAnswer',
}

export default {
  components: {
    QuestionContent,
    TwoColumnQuizReview,
    ShortAnswer,
    CorrectOrder,
    MatchPair,
    ListSubmission,
    BlockSubmission,
  },
  props: {
    answer: {
      type: Object,
      default: () => {},
    },
    order: {
      type: Number,
      default: 1,
    },
    totalQuiz: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    answerComponent() {
      const slideType = this.answer.question_type || 'pickAnswer'
      return answerComponentMap[slideType]
    },
    question() {
      return {
        id: this.answer.question_id,
        type: this.answer.question_type,
        title: this.answer.question_title,
        image: this.answer.question_image,
        description: this.answer.question_description,
      }
    },
    scoring() {
      const isQuizType = QUIZ_TYPES.includes(this.answer.question_type)
      if (!isQuizType) return null
      return {
        result: this.answer.answer_result,
        point: this.answer.points_earned,
        time: this.answer.time_answer,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.answers-and-submissions {
  color: var(--base-90, #313131);
}
</style>
